export default __webpack_public_path__ + "static/media/Evento_4.59e625ae.jpg";